export enum RacingStateIds {
    AP = 1,
    NRNB = 2,
    DOE = 3,
    SP = 4
}